import React, { Component } from "react";
import classnames from "classnames";
import { observer } from "mobx-react";

import { withoutReservedTags } from "@formant/core/common/withoutReservedTags";
import { ITags } from "@formant/core/model/ITags";
import { ITagSets } from "@formant/core/model/ITagSets";

import { authStore } from "../../../stores";
import * as styles from "./index.scss";
import { TagSelect } from "./TagSelect";

export interface ISelectTagsProps {
    value: ITags;
    tags: ITagSets;
    keys: string[];
    includeNone?: boolean;
    className?: string;
    disableInheritedTags?: boolean;
    onChange: (value: ITags) => void;
}

@observer
export class SelectTags extends Component<ISelectTagsProps> {
    private inheritedTags: ITags = !this.props.disableInheritedTags
        ? withoutReservedTags(authStore.userTags || {})
        : {};

    public componentDidMount() {
        const { value } = this.props;
        const { inheritedTags } = this;

        if (
            this.props.disableInheritedTags ||
            !Object.keys(inheritedTags).length
        ) {
            return;
        }

        this.props.onChange({
            ...value,
            ...inheritedTags,
        });
    }

    public render() {
        const { className, value, keys, tags, includeNone } = this.props;
        const { inheritedTags } = this;
        const inheritedItems = Object.keys(inheritedTags || {}).sort();
        const items = [...new Set([...keys, ...Object.keys(value)])]
            .filter(_ => !inheritedTags[_])
            .sort();

        return (
            <div className={classnames(styles["select-tags"], className)}>
                {inheritedItems.map(key => (
                    <TagSelect
                        key={key}
                        tagKey={key}
                        value={inheritedTags[key]}
                        valueOptions={tags?.[key] || []}
                        includeNone={includeNone}
                        className={styles["select-inherited"]}
                        onChange={this.onChangeTagValue}
                        tooltipText="These tags were set by your administrator and can’t be altered. For more information, please talk to your administrator"
                        immutable={true}
                    />
                ))}
                {items.map(key => (
                    <TagSelect
                        key={key}
                        tagKey={key}
                        value={value[key]}
                        valueOptions={tags?.[key] || []}
                        includeNone={includeNone}
                        className={styles.select}
                        onChange={this.onChangeTagValue}
                    />
                ))}
            </div>
        );
    }

    private onChangeTagValue = (key: string, tagValue: string | undefined) => {
        const { onChange } = this.props;
        const { [key]: ignore, ...value } = this.props.value;
        if (tagValue === undefined) {
            onChange(value);
        } else {
            onChange({
                ...value,
                [key]: tagValue,
                ...this.inheritedTags,
            });
        }
    };
}
